import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteNotification } from "./deleteNotification.request";

const useDeleteNotification = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteNotification,
    ...options
  });
};

export default useDeleteNotification;
